import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { businessTypeOptions } from 'src/api/types';
import { BusinessType } from 'src/graphql/_generated';

interface BusinessTypeSelectProps extends Omit<Props, 'value' | 'options'> {
  value: BusinessType | undefined | null;
  onChange: (
    value: { label: string; value: BusinessType },
    meta: ActionMeta<{ label: string; value: BusinessType }>,
  ) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  restrictedTo?: BusinessType[];
}

export const BusinessTypeSelect: React.FC<BusinessTypeSelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select business type',
  restrictedTo,
  ...rest
}) => {
  const options = restrictedTo
    ? businessTypeOptions.filter((option) => restrictedTo.includes(option.value))
    : businessTypeOptions;

  const selectedValue = value ? _.find(businessTypeOptions, (o) => o.value === value) : null;

  return (
    <>
      <CSelect
        isDisabled={disabled || !options.length}
        value={selectedValue}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        onBlur={onBlur}
        inputId="business-type-select"
        name="businessType"
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
